/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Supports regular logging, collapsible groups, and table formatting with color-coded status styles.
 * Only outputs logs when DEBUG flag is true.
 */
(function (g) {
  const DEBUG = window.Shopify?.theme?.role === 'development' || window.Shopify?.theme?.role === 'unpublished',
    styles = {
      success: "background:darkgreen;color:white;padding:2px 6px;border-radius:3px",
      error: "background:darkred;color:white;padding:2px 6px;border-radius:3px",
      warning: "background:darkorange;color:white;padding:2px 6px;border-radius:3px",
      info: "background:blue;color:white;padding:2px 6px;border-radius:3px",
      filename: "background:#333;color:#bada55;padding:2px 6px;border-radius:3px;margin-left:4px"
    };

  const getCallerFile = () => {
    try {
      return (new Error().stack.split('\n').find(l => (l.includes('/assets/') || l.includes('/sections/') || l.includes('/snippets/')) && !l.includes('/custom_sitewide.js') || !l.includes('jquery-')) || '')
        .match(/\/(assets|sections|snippets)\/([^:?]+)\??/)?.[2] || '';
    } catch (e) { return ''; }
  };

  const log = (...args) => DEBUG && console.log(...args);

  const collapse = (type, data, title = "Log", status = "info") => {
    if (!DEBUG) return;
    const file = getCallerFile();
    console.groupCollapsed(`%c ${title}${file ? ' %c' + file : ''}`,
      styles[status] || styles.info, file ? styles.filename : '');
    type === "table" ? console.table(data) : console.log(data);
    console.groupEnd();
  };

  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);

const log = window.log;


/**
 * Initializes and manages a Slick carousel with separate mobile and desktop configurations.
 * Ensures no unnecessary reinitialization during window resizing.
 *
 * @param {jQuery} carousel - The carousel element(s).
 * @param {Object} mobileOptions - Slick options for mobile view.
 * @param {number} breakpoint - The breakpoint to switch between mobile and desktop configurations.
 * @param {Object|null} desktopOptions - Slick options for desktop view. If null, unslick on desktop.
 */
function handleResponsiveCarousel(carousel, mobileOptions, breakpoint = 1024, desktopOptions = null) {
  let currentView = null; // Keeps track of the current view ('mobile' or 'desktop')

  function initializeCarousel() {
    const isDesktop = $(window).width() >= breakpoint;

    if (isDesktop) {
      if (currentView !== 'desktop') {
        // Switch to desktop view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy mobile Slick if initialized
        if (desktopOptions) carousel.slick(desktopOptions); // Initialize with desktop options
        currentView = 'desktop';
      }
    } else {
      if (currentView !== 'mobile') {
        // Switch to mobile view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy desktop Slick if initialized
        carousel.slick(mobileOptions); // Initialize with mobile options
        currentView = 'mobile';
      }
    }
  }

  initializeCarousel();
  // Throttle resize to avoid excessive reinitialization
  let resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initializeCarousel, 250);
  });
}

/**
 * Adds sticky bar visibility logic below a target section.
 *
 * Example usage:
 *   bindStickyBar('.na_sticky_bar_outer', '.pdp-main', 320);
 *
 * @param {string|HTMLElement|jQuery} stickyBarSelectorOrEl - Selector, jQuery, or HTMLElement for the sticky bar.
 * @param {string|HTMLElement|jQuery} scrollPastSelectorOrEl - Selector, jQuery, or HTMLElement for the element to scroll past.
 * @param {number} [threshold=200] - Optional. Pixels below bottom to trigger, default 200.
 */
function bindStickyBar(stickyBarSelectorOrEl, scrollPastSelectorOrEl, threshold = 200) {
  const $stickyBar = $(stickyBarSelectorOrEl);
  const $scrollPast = $(scrollPastSelectorOrEl);

  if (!$stickyBar.length || !$scrollPast.length) return;

  function checkStickyBar() {
    const rect = $scrollPast[0].getBoundingClientRect();
    const triggersSticky = rect.bottom < (window.innerHeight - threshold);
    $stickyBar.toggleClass('active', triggersSticky);
  }

  $(window).on('scroll resize', checkStickyBar);
  checkStickyBar();
}
window.bindStickyBar = bindStickyBar;

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}

function showCopyNotification() {
  const $n = $('<div class="copy-notification">Copied!</div>').appendTo('body');
  setTimeout(() => $n.css({ opacity: 1, transform: 'translateY(0)' }), 10);
  setTimeout(() => { $n.css({ opacity: 0, transform: 'translateY(20px)' }); setTimeout(() => $n.remove(), 200); }, 1500);
}



$(document).ready(function () {
  $('a[href="#"][title="Copy to Clipboard"]').on('click', function (e) {
    e.preventDefault();
    const text = $(this).data('copy') || $(this).text().trim();
    copyToClipboard(text);
    showCopyNotification();
    log.collapse({ text, parent: $(this).parent().parent() }, 'Copied to Clipboard', 'success');
  });


  const useChevron = false;
  const icons = {
    arrow_left: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Left.svg?v=1744058170',
    arrow_right: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Right.svg?v=1744058170',
    chevron_left: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/chevron_left.svg?v=1745952252',
    chevron_right: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/chevron_right.svg?v=1745952252'
  };
  const buttons = {
    prevArrow: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${useChevron ? icons.chevron_left : icons.arrow_left}' alt='arrow'/></button>`,
    nextArrow: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${useChevron ? icons.chevron_right : icons.arrow_right}' alt='arrow'/></button>`,
    prevArrowChevron: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${icons.chevron_left}' alt='arrow'/></button>`,
    nextArrowChevron: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${icons.chevron_right}' alt='arrow'/></button>`
  }


  $('.split-hero__reviews.multiple').slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.testimonials__cards').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '40px',
    arrows: true,
    dots: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          centerPadding: '30px'
        }
      }
    ]
  });

  const videoReviews = $('.video-reviews__wrapper');
  const videoReviewsOptions = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    variableWidth: true,
    prevArrow: buttons.prevArrowChevron,
    nextArrow: buttons.nextArrowChevron,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: !videoReviews.hasClass('slick-progress')
        }
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          arrows: !videoReviews.hasClass('slick-progress')
        }
      }
    ]
  }
  videoReviews.slick(videoReviewsOptions);

  $('.pr-item__product-images.gallery-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
  });

  $('.product-showcase__products.pdp-description').slick({
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  });

  $('.rp-slider__products').slick({
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.pdp-main__reviews.multiple').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.pdp-main__images .product-images.thumbnails-mobile[data-images="thumbnails"]').each(function () {
    const container = $(this);
    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent image dragging
    container.find('img, video').attr('draggable', false);

    // Mouse events for scrolling
    container
      .on('mousedown', function (e) {
        isDown = true;
        container.addClass('grabbing');
        startX = e.pageX;
        scrollLeft = container.scrollLeft();
        e.preventDefault();
      })
      .on('touchstart', function (e) {
        isDown = true;
        container.addClass('grabbing');
        startX = e.originalEvent.touches[0].pageX;
        scrollLeft = container.scrollLeft();
      })
      .on('mouseleave mouseup', function () {
        isDown = false;
        container.removeClass('grabbing');
      })
      .on('touchend touchcancel', function () {
        isDown = false;
        container.removeClass('grabbing');
      })
      .on('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX;
        const walk = (startX - x) * 1.5;
        container.scrollLeft(scrollLeft + walk);
      })
      .on('touchmove', function (e) {
        if (!isDown) return;
        const x = e.originalEvent.touches[0].pageX;
        const walk = (startX - x) * 1.5;
        container.scrollLeft(scrollLeft + walk);
        e.preventDefault(); // Prevent page scrolling while dragging thumbnails
      });

    // Click on thumbnails to navigate
    container.on('click', 'div:not(.product-image):has(> video, > img, > .product-image[data-type="video"])', function () {
      if (isDown) return; // Don't trigger click when dragging
      const index = $(this).data('index');
      $('.pdp-main__images .product-images.slick-initialized[data-images="all"]')
        .slick('slickGoTo', index);
    });
  });

  $('.draggable-slider').each(function () {
    const slider = $(this);
    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent image dragging
    slider.find('img').attr('draggable', false);

    // Mouse events for scrolling
    slider
      .on('mousedown', function (e) {
        isDown = true;
        slider.addClass('grabbing');
        startX = e.pageX;
        scrollLeft = slider.scrollLeft();
        e.preventDefault();
      })
      .on('touchstart', function (e) {
        isDown = true;
        slider.addClass('grabbing');
        startX = e.originalEvent.touches[0].pageX;
        scrollLeft = slider.scrollLeft();
      })
      .on('mouseleave mouseup', function () {
        isDown = false;
        slider.removeClass('grabbing');
      })
      .on('touchend touchcancel', function () {
        isDown = false;
        slider.removeClass('grabbing');
      })
      .on('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX;
        const walk = (startX - x) * 1.5;
        slider.scrollLeft(scrollLeft + walk);
      })
      .on('touchmove', function (e) {
        if (!isDown) return;
        const x = e.originalEvent.touches[0].pageX;
        const walk = (startX - x) * 1.5;
        slider.scrollLeft(scrollLeft + walk);
        e.preventDefault(); // Prevent page scrolling while dragging
      });
  });



  const pdpImages = $('.pdp-main__images .product-images[data-images="all"]');
  const pdpImagesOptions = {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrowChevron,
    nextArrow: buttons.nextArrowChevron,
    slidesToShow: 1,
    slidesToScroll: 1
  }
  const pdpImagesDesktopOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrowChevron,
    nextArrow: buttons.nextArrowChevron,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  const TPReviews = $('.tp-reviews__cards');
  const TPRevewsOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrowChevron,
    nextArrow: buttons.nextArrowChevron,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: !TPReviews.hasClass('slick-progress')
        }
      }
    ]
  };
  const TPRevewsDesktopOptions = $('.tp-reviews__cards.desktop-carousel').length ? {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrowChevron,
    nextArrow: buttons.nextArrowChevron,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  } : null;

  const ProductShowcase = $('.product-showcase__products:not(.pdp-description)');
  const ProductShowcaseOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  };

  handleResponsiveCarousel(TPReviews, TPRevewsOptions, 980, TPRevewsDesktopOptions);
  handleResponsiveCarousel(ProductShowcase, ProductShowcaseOptions, 753);
  handleResponsiveCarousel(pdpImages, pdpImagesOptions, 1024, pdpImagesDesktopOptions);

  // Video reviews --------------------------------------------------------
  $('[data-video-controls="true"] .video-reviews__video-button.play, .video-reviews__video[data-video-controls="true"]').click(function () {
    const $videoWrapper = $(this).is('.video-reviews__video') ? $(this) : $(this).closest('.video-reviews__video');
    const $video = $videoWrapper.find('video');

    if ($video.length) {
      // Autoplay mode: just toggle mute/unmute, don't pause/play
      if ($videoWrapper.hasClass('autoplay')) {
        const isCurrentlyMuted = $video.get(0).muted;
        if (isCurrentlyMuted) {
          $video.prop('muted', false).prop("volume", 0.5);
          $videoWrapper.addClass('play').find('.video-reviews__video-button.pause').css('display', 'flex');
          $videoWrapper.find('.video-reviews__video-button.play').hide();
        } else {
          $video.prop('muted', true);
          $videoWrapper.removeClass('play').find('.video-reviews__video-button.pause').hide();
          $videoWrapper.find('.video-reviews__video-button.play').css('display', 'flex');
        }
        return;
      }

      // Default mode: existing functionality
      if (!$video.get(0).paused) {
        $video.get(0).pause();
        $videoWrapper.removeClass('play').find('.video-reviews__video-button.pause').hide();
        $videoWrapper.find('.video-reviews__video-button.play').css('display', 'flex');
        return;
      }
      $('.video-reviews__video[data-video-controls="true"]').each(function () {
        const $otherWrapper = $(this);
        const $otherVideo = $otherWrapper.find('video');
        if ($otherVideo.get(0) !== $video.get(0)) {
          $otherVideo.prop('muted', true).get(0).pause();
          $otherWrapper.removeClass('play').find('.video-reviews__video-button.play').css('display', 'flex');
          $otherWrapper.find('.video-reviews__video-button.pause').hide();
        }
      });

      $video.prop('muted', false).prop("volume", 0.5).get(0).play();
      $(this).is($videoWrapper) ? $videoWrapper.find('.video-reviews__video-button.play').hide() : $(this).hide();
      $videoWrapper.addClass('play').find('.video-reviews__video-button.pause').css('display', 'flex');
    }
  });
  $('[data-video-controls="true"] .video-reviews__video-button.play').click(function (e) {
    e.stopPropagation();
  })


  // Announcement Timer
  function AnnouncementTimer() {
    const timerWrap = $('.announcement__timer, .announcement__timer-labeled');
    if (!timerWrap.length) return;

    let time;
    const timerDate = timerWrap.data('timer-date');
    if (timerDate) {
      const targetTime = new Date(timerDate + "T00:00:00"); // Local midnight of the given date
      time = Math.floor((targetTime - new Date()) / 1000); // Time difference in seconds
    } else {
      time = parseInt(timerWrap.data('time'), 10);
    }

    if (time <= 0) return timerWrap.hide(); // Ensures valid countdown

    const calculateTime = () => {
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;
      return { hours, minutes, seconds };
    };

    const updateSimple = ({ hours, minutes, seconds }) => {
      timerWrap.find('.timer').text([hours, minutes, seconds]
        .map(v => v.toString().padStart(2, '0')).join(':'));
    };
    const updateLabeled = ({ hours, minutes, seconds }) => {
      console.log(hours, minutes, seconds);
      timerWrap.find('.hours').text(hours.toString().padStart(2, '0'));
      timerWrap.find('.minutes').text(minutes.toString().padStart(2, '0'));
      timerWrap.find('.seconds').text(seconds.toString().padStart(2, '0'));
    };

    const update = () => {
      if (time < 0) return timerWrap.hide();
      timerWrap.hasClass('announcement__timer-labeled') ? updateLabeled(calculateTime()) : updateSimple(calculateTime());
      time--;
    };

    update();
    setInterval(update, 1000);
  }

  // Easter Banner Timer
  function EasterBannerTimer(usePDT = false) {
    const timerElement = $('.easter-banner__timer-value');
    if (!timerElement.length) return;

    const endDate = new Date('April 25, 2025 23:59:59').getTime();

    function updateTimer() {
      // If using PDT, adjust time by calculating PDT from UTC
      const now = usePDT
        ? new Date().getTime() + (new Date().getTimezoneOffset() * 60000) - (7 * 3600000)
        : new Date().getTime();

      const timeLeft = endDate - now;
      if (timeLeft <= 0) return timerElement.parent().hide();

      const days = Math.floor(timeLeft / 86400000);
      const hours = Math.floor(timeLeft % 86400000 / 3600000);
      const minutes = Math.floor(timeLeft % 3600000 / 60000);
      const seconds = Math.floor(timeLeft % 60000 / 1000);

      timerElement.text(days > 0
        ? `${days} Days ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        : `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // Stats Section --------------------------------------------------------
  function initStats() {
    const $statsSection = $('.stats');
    if (!$statsSection.length) return;

    const animateNumber = ($element, goal) => {
      const start = performance.now();
      const duration = 2500;
      const easing = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      const update = (currentTime) => {
        const elapsed = currentTime - start;
        const progress = Math.min(elapsed / duration, 1);
        const current = Math.floor(goal * easing(progress));
        $element.text(current.toLocaleString());
        if (progress < 1) requestAnimationFrame(update);
        else $element.text(goal.toLocaleString());
      };
      requestAnimationFrame(update);
    };

    let animated = false;
    const checkView = () => {
      if (!animated && $statsSection.offset().top < $(window).height()) {
        $('.stats__item').each(function () {
          const $item = $(this);
          const goalNumber = parseInt($item.find('.stats__item-number').data('number'));
          const $numberElement = $item.find('.stats__item-number span');
          if (goalNumber !== 0) animateNumber($numberElement, goalNumber);
        });
        animated = true;
        $(window).off('scroll', checkView);
      }
    };

    $(window).on('scroll', checkView);
    checkView();
  }

  initStats();

  // Initialize section code
  if ($('.announcement__timer, .announcement__timer-labeled').length > 0) {
    AnnouncementTimer();
    $('.announcement__text a').on('click', function (e) {
      e.preventDefault();
      var text = $(this).text().trim();
      copyToClipboard(text);
      log.collapse(text, 'Copied to Clipboard');
    });
  }

  // Initialize Easter Banner Timer
  if ($('.easter-banner__timer-value').length > 0) {
    // Pass true to use PDT timezone, false or nothing to use local time
    EasterBannerTimer(true);
  }

  $('.ScrollToProduct').on('click', function (e) {
    e.preventDefault();
    const offsetTop = $('#product-main').offset().top - 160;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 600);
  });

  $('.AddToCart').on('click', function (e) {
    e.preventDefault();
    const variantId = $(this).data('id');
    $.post('/cart/add.js', {
      items: [{ id: variantId, quantity: 1 }]
    }, function (response) {
      log.collapse(response, 'Added to Cart', 'success');
      window.updateCartDrawer();
    }).fail(function (response) {
      log.collapse(response, 'Add to Cart Failed', 'error');
    });
  });

  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    if ($(this).hasClass("is-active")) {
      $(this).removeClass("is-active").children(".accordion-panel").slideUp("ease-out");
    } else {
      $(this).addClass("is-active").children(".accordion-panel").slideDown("ease-out");
    }
  });

  $('.hh_collapsible_tab').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
  });

  // ------------------------ Product Options --Custom Dropdown -----------------------------------
  // -- USED IN: Cart Drawer items, Cart Drawer upsells, Cart Drawer gift popup, PDP Main, PDP Bundle --
  $('.main-select__label').on('click', function (e) {
    e.stopPropagation();
    const $select = $(this).closest('.main-select');
    $('.main-select').not($select).removeClass('open');
    $select.toggleClass('open');
  });

  // Update button text when an option is selected
  $('.main-select__item').on('click', function () {
    const $this = $(this);
    const selectedText = $this.find('.item-label').text().trim();
    const $select = $this.closest('.main-select');
    $select.find('.main-select__item').removeAttr('data-selected');
    $this.attr('data-selected', 'true');
    $select.find('.main-select__label p').text(selectedText);
    $this.hasClass('color') && $select.find('.main-select__label .main-color-swatch div').attr('style', $this.find('.main-color-swatch div').attr('style'));
  });

  // Smart dropdown positioning to prevent viewport overflow
  $('.main-select__label').on('click', function () {
    const $select = $(this).closest('.main-select');
    const $menu = $select.find('.main-select__menu');

    $menu.removeClass('above right');

    setTimeout(() => {
      const menuRect = $menu[0].getBoundingClientRect();
      const { innerHeight: vh, innerWidth: vw } = window;

      if (menuRect.bottom > vh - 20) $menu.addClass('above');
      if (menuRect.right > vw - 20) $menu.addClass('right');
    }, 10);
  });

  // Close dropdown when clicking outside
  $(document).on('click', () => $('.main-select').removeClass('open'));

  // ----------------------- Handle Modals -----------------------
  function handleModal(modalSelector, triggerSelector) {
    const $modal = $(modalSelector);
    let lastScrollY = null;

    // Open modal
    $(triggerSelector).on('click', function () {
      lastScrollY = window.scrollY;
      $modal.addClass('active').attr('aria-hidden', 'false').fadeIn();
      $('body').addClass('no-scroll');
      $('#main').css({
        'z-index': '21',
        'position': 'relative'
      });
    });

    // Close modal
    $('.modal-close, .modal-overlay').on('click', function () {
      $modal.removeClass('active').attr('aria-hidden', 'true').fadeOut();
      $('body').removeClass('no-scroll');
      $('#main').css({
        'z-index': 'unset',
        'position': 'unset'
      });
      if (lastScrollY !== null) setTimeout(() => window.scrollTo({ top: lastScrollY, behavior: 'instant' }), 10);
    });
  }
  // Initialize modals
  handleModal('#nutrition-table-modal', '.pdp-main__nutrition-table-btn, .pdp-main-bundle__nutrition-table-btn');
  handleModal('#pdp-main-popup', '.pdp-main-bundle__product-learn-more, .pdp-main-bundle__gift');

})

// Sticky bar hide JS START
document.addEventListener("DOMContentLoaded", () => {
  const stickyButton = document.querySelector(
    ".daily-gummies-compliant-2 .promo-sticky-button-bar"
  );

  const triggerElement = document.querySelector(
    ".daily-gummies-compliant-2 .mpv1-switchers__footer"
  );

  if (!stickyButton || !triggerElement) return;

  function toggleStickyButton() {
    const rect = triggerElement.getBoundingClientRect();

    // SHOW only after user scrolls past the section
    if (rect.top <= 0) {
      stickyButton.style.display = "block";
    } else {
      // HIDE again when scrolling back to top
      stickyButton.style.display = "none";
    }
  }

  // Initial state
  toggleStickyButton();

  // On scroll
  window.addEventListener("scroll", toggleStickyButton);
});
// Sticky bar hide JS END